import { Box, Step, StepButton, Stepper } from '@mui/material';
import { isEmpty } from 'lodash';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import {
  CheckoutStep,
  checkoutSteps,
  useValidateAddress,
  useValidatePayment,
  useValidateProfile,
} from './utils';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type CheckoutStepperProps = {
  form: PaymentForm;
  currentStep: CheckoutStep;
  setCurrentStep: (step: CheckoutStep) => void;
};

export const CheckoutStepper = ({
  form,
  currentStep,
  setCurrentStep,
}: CheckoutStepperProps) => {
  const t = useLocalizedText();

  const profileErrors = useValidateProfile(form);
  const addressErrors = useValidateAddress(form);
  const paymentErrors = useValidatePayment(form);

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper nonLinear activeStep={checkoutSteps.indexOf(currentStep)}>
        <Step completed={isEmpty(profileErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('profile')}>
            {t('checkout.step.profile')}
          </StepButton>
        </Step>

        <Step completed={isEmpty(addressErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('address')}>
            {t('checkout.step.address')}
          </StepButton>
        </Step>

        <Step completed={isEmpty(paymentErrors)}>
          <StepButton color='inherit' onClick={() => setCurrentStep('payment')}>
            {t('checkout.step.payment')}
          </StepButton>
        </Step>
      </Stepper>
    </Box>
  );
};
